export const Colours = {
	primary: "#0061E8",
	secondary: "#092A58",
	tertiary: "#6A9898",
	grey: "#CED4DE",
	lightGrey: "#EBEEF2",
	excelerateOrange: "#F36F21",
	driveableGreen: "#6CC24A",
	warn: "#FFDD00",
	error: "#F70F4A",
	success: "#6CC24A",
	purple: "#8D3FD0",
	magenta: "#7898FB",
};

// Plain object (StyleSheet.create is an identity function) so importing
// Colours doesn't pull react-pdf into the main bundle.
export const ReportFonts = {
	regular: {
		fontFamily: "Inter",
		fontWeight: 400,
	},
	italic: {
		fontFamily: "Inter",
		fontWeight: 400,
		fontStyle: "italic",
	},
	bold: {
		fontFamily: "Inter",
		fontWeight: 700,
	},
	boldItalic: {
		fontFamily: "Inter",
		fontWeight: 700,
		fontStyle: "italic",
	},
	extraBold: {
		fontFamily: "Inter",
		fontWeight: 800,
	},
	light: {
		fontFamily: "Inter",
		fontWeight: 300,
	},
} as const;
